<template>
  <div class="container xl:max-w-(--breakpoint-xl) mx-auto grid lg:grid-cols-8 gap-4 px-8 mt-12">
    <div class="lg:col-span-5 text-left text-h1-starter text-base content-text-wrapper">
      <UiLanguagePlaceholder
        :domain="getLanguagePlaceholdersDomainForPage()"
        name="top"
        :variables="{
          portal_site: (links?.portal_domain_name ?? ''),
          agb: links?.frequently_used_links?.agb?.url,
          privacy_policy: links?.frequently_used_links?.privacy_policy?.url,
          contact: links?.frequently_used_links?.contact?.url
        }"
      />
    </div>
    <div class="lg:col-span-3 text-left text-h2-starter text-base content-text-wrapper">
      <UiLanguagePlaceholder
        :domain="getLanguagePlaceholdersDomainForPage()"
        name="bottom"
        :variables="{
          portal_site: (links?.portal_domain_name ?? ''),
          portal_region: (links?.location ?? ''),
          ferienwohnung_vermieten_url: (links?.ferienwohnung_vermieten_url ?? '')
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  pagedata: {
    type: Object,
    default: null
  }
})
const { links, main } = usePortalData()
const getLanguagePlaceholdersDomainForPage = () => {
  const key = props.pagedata.urldata.pagetype_data.key
  const pageKeySuffixes = main?.language_placeholders?.page_key_suffixes || {}
  let domain = `page.${key}`
  if (!Object.prototype.hasOwnProperty.call(pageKeySuffixes, key)) {
    return domain
  }

  const domainSuffix = pageKeySuffixes[key]
  if (!domainSuffix) {
    return domain
  }

  domain += `${domainSuffix}`
  return domain
}
</script>
<style scoped>
@reference "~/assets/css/main.css";
.text-h1-starter{
  :deep(h1){
    @apply text-3xl md:text-5xl font-bold mt-12 mb-12;
    &:first-child{
      @apply mt-0
    }
    + h2, + h3, + h4, + h5, + h6{
      @apply mt-0
    }
  }
  :deep(h2){
    @apply text-2xl md:text-4xl font-semibold mt-12 mb-4
  }
  :deep(h3){
    @apply text-xl md:text-2xl font-semibold mt-12 mb-4
  }
  :deep(a){
    @apply text-petrol-500 underline hover:text-petrol-800
  }
  :deep(ul){
    @apply list-disc list-outside ml-4;
  }
  :deep(li){
    @apply mb-3;
  }
}
.text-h2-starter{
  :deep(h1){
    @apply text-3xl md:text-5xl font-bold mt-12 mb-12;
    + h2, + h3, + h4, + h5, + h6{
      @apply mt-0
    }
  }
  :deep(h2){
    @apply text-2xl md:text-4xl font-semibold mt-12 mb-4;
    &:first-child{
      @apply mt-0
    }
  }
  :deep(h3){
    @apply text-xl md:text-2xl font-semibold mt-12 mb-4;
  }
  :deep(a){
    @apply text-petrol-500
  }
}
</style>
